import styled, { keyframes } from 'styled-components';

import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

type BackgroundProps = {
  speed: number;
};

export type SkeletonProps = {
  height?: number | string;
  width?: number | string;
  isRound?: boolean;
  isLoading?: boolean;
};

export const defaultShimmerSpeed = 3000;

export const loadingAnimation = keyframes`
  from {
    transform: translateX(-20%);

  }
  to {
    transform: translateX(120%);
  }
`;

// no need to convert to REM values since shimmer effect doesn't need to scale proportionally
export const Background = styled.div<BackgroundProps>`
  animation: ${loadingAnimation} ${(props) => props.speed / 1000}s linear infinite;
  background: linear-gradient(90deg, transparent 10px, ${colors.grey1} 20px, ${colors.grey5} 40px);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const getValue = (value: number | string) => {
  if (typeof value === 'number') {
    return pxToRem(value);
  }
  return value;
};

export const StyledSkeleton = styled.div<SkeletonProps>`
  height: ${({ height }) => {
    return height ? getValue(height) : '100%';
  }};
  width: ${({ width }) => (width ? getValue(width) : '100%')};
  position: relative;

  background-color: ${({ isLoading }) => (isLoading ? colors.grey5 : 'inherit')};
  background-repeat: no-repeat;
  overflow: hidden;

  border-radius: ${({ isRound, height }) =>
    isRound && height ? `calc(${getValue(height)}/ 2)` : spacing.quarter};
`;
